import { render } from "./Latest.vue?vue&type=template&id=e64c4be6&scoped=true"
import script from "./Latest.vue?vue&type=script&lang=js"
export * from "./Latest.vue?vue&type=script&lang=js"

import "./Latest.vue?vue&type=style&index=0&id=e64c4be6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64c4be6"]])

export default __exports__